var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.selectedButtonToComponent[_vm.selectedButton],{tag:"component",class:`rubric-${_vm.selectedButton} new-rubric-view`,on:{"createRubric":function($event){return _vm.createNewRubric($event)},"close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }